/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {OperationalScopeDTO} from '../model/OperationalScopeDTO';
import {OperationalScopeGetResponseDTO} from '../model/OperationalScopeGetResponseDTO';
import {OperationalScopePostRequestDTO} from '../model/OperationalScopePostRequestDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* OperationalScopeServices service.
* @module api/OperationalScopeServicesApi
* @version v0
*/
export class OperationalScopeServicesApi {

    /**
    * Constructs a new OperationalScopeServicesApi. 
    * @alias module:api/OperationalScopeServicesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the deleteOperationalScopeById operation.
     * @callback moduleapi/OperationalScopeServicesApi~deleteOperationalScopeByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete Operational Scope
     * Request to delete an Operational Scope given the id.
     * @param {Number} operationalScopeId 
     * @param {module:api/OperationalScopeServicesApi~deleteOperationalScopeByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteOperationalScopeById(operationalScopeId, callback) {
      
      let postBody = null;
      // verify the required parameter 'operationalScopeId' is set
      if (operationalScopeId === undefined || operationalScopeId === null) {
        throw new Error("Missing the required parameter 'operationalScopeId' when calling deleteOperationalScopeById");
      }

      let pathParams = {
        'operationalScopeId': operationalScopeId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/operational-scope/{operationalScopeId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOperationalScopeById operation.
     * @callback moduleapi/OperationalScopeServicesApi~getOperationalScopeByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OperationalScopeGetResponseDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Operational Scope
     * Request to get Operational Scope
     * @param {Number} operationalScopeId 
     * @param {module:api/OperationalScopeServicesApi~getOperationalScopeByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOperationalScopeById(operationalScopeId, callback) {
      
      let postBody = null;
      // verify the required parameter 'operationalScopeId' is set
      if (operationalScopeId === undefined || operationalScopeId === null) {
        throw new Error("Missing the required parameter 'operationalScopeId' when calling getOperationalScopeById");
      }

      let pathParams = {
        'operationalScopeId': operationalScopeId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = OperationalScopeGetResponseDTO;

      return this.apiClient.callApi(
        '/api/operational-scope/{operationalScopeId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getOperationalScopeMonitor operation.
     * @callback moduleapi/OperationalScopeServicesApi~getOperationalScopeMonitorCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/OperationalScopeDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of Operational Scopes
     * Request to get the list of all the Operational Scopes.
     * @param {module:api/OperationalScopeServicesApi~getOperationalScopeMonitorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getOperationalScopeMonitor(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [OperationalScopeDTO];

      return this.apiClient.callApi(
        '/api/operational-scope/monitor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the newOperationalScope operation.
     * @callback moduleapi/OperationalScopeServicesApi~newOperationalScopeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create new Operational Scope
     * Request to add a new Operational Scope.
     * @param {module:model/OperationalScopePostRequestDTO} body 
     * @param {module:api/OperationalScopeServicesApi~newOperationalScopeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    newOperationalScope(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling newOperationalScope");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/operational-scope', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateOperationalScopeById operation.
     * @callback moduleapi/OperationalScopeServicesApi~updateOperationalScopeByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Operational Scope
     * Request to update Operational Scope
     * @param {module:model/OperationalScopePostRequestDTO} body 
     * @param {Number} operationalScopeId 
     * @param {module:api/OperationalScopeServicesApi~updateOperationalScopeByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateOperationalScopeById(body, operationalScopeId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateOperationalScopeById");
      }
      // verify the required parameter 'operationalScopeId' is set
      if (operationalScopeId === undefined || operationalScopeId === null) {
        throw new Error("Missing the required parameter 'operationalScopeId' when calling updateOperationalScopeById");
      }

      let pathParams = {
        'operationalScopeId': operationalScopeId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/operational-scope/{operationalScopeId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}